import { UniqueIdentifier, useDroppable } from '@dnd-kit/core';
import {
  horizontalListSortingStrategy,
  SortableContext,
} from '@dnd-kit/sortable';

export default function SortableContainer({
  id,
  items,
  className,
  children,
}: {
  id: UniqueIdentifier;
  items: UniqueIdentifier[];
  className?: string;
  children: React.ReactNode | React.ReactNode[];
}) {
  const { setNodeRef } = useDroppable({ id });

  return (
    <div ref={setNodeRef} className={className}>
      <SortableContext items={items} strategy={horizontalListSortingStrategy}>
        {children}
      </SortableContext>
    </div>
  );
}
